import React from 'react'

import AddCompanyProductForm from '../../modules/CompanyProduct/components/AddCompanyProductForm'
export default function AddCompanyProductPage() {
  return (
    <AddCompanyProductForm/>  )
}
